import { useEffect, useState } from "react";
import { api, apiErr } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import ImageUpload from "@/components/ImageUpload";

export default function TenantBanners() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ title: "", image: "", link: "", position: "home", is_active: true, sort_order: 0 });
  const refresh = () => api.get("/tenant/banners").then(({ data }) => setItems(data));
  useEffect(() => { refresh(); }, []);
  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post("/tenant/banners", form);
      setForm({ title: "", image: "", link: "", position: "home", is_active: true, sort_order: 0 });
      refresh();
    } catch (e) { toast.error(apiErr(e)); }
  };
  const del = async (id) => { if (confirm("Delete banner?")) { await api.delete(`/tenant/banners/${id}`); refresh(); } };

  return (
    <div className="p-8">
      <h1 className="font-display text-3xl font-bold tracking-tight mb-1" data-testid="tenant-banners-title">Banners</h1>
      <p className="text-slate-500 text-sm mb-6">Hero images shown on your storefront home & category pages.</p>
      <Card className="p-5 border-slate-200">
        <form onSubmit={add} className="grid md:grid-cols-3 gap-3">
          <Input placeholder="Title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="banner-title-input" />
          <div className="md:col-span-2">
            <ImageUpload value={form.image} onChange={(v) => setForm({ ...form, image: v })} kind="banner" testId="banner-image" aspect="aspect-[4/2]" />
          </div>
          <Input placeholder="Link (optional)" value={form.link} onChange={(e) => setForm({ ...form, link: e.target.value })} data-testid="banner-link-input" />
          <div className="flex items-center gap-2"><Switch checked={form.is_active} onCheckedChange={(v) => setForm({ ...form, is_active: v })} /><Label>Active</Label></div>
          <Input placeholder="Sort" type="number" value={form.sort_order} onChange={(e) => setForm({ ...form, sort_order: +e.target.value })} />
          <Button type="submit" data-testid="banner-add-btn"><Plus className="h-4 w-4 mr-2" />Add Banner</Button>
        </form>
      </Card>
      <div className="grid md:grid-cols-2 gap-4 mt-4">
        {items.map((b) => (
          <Card key={b.id} className="p-3 overflow-hidden border-slate-200" data-testid={`banner-row-${b.id}`}>
            {b.image && <img src={b.image} className="w-full h-32 object-cover rounded" alt={b.title} />}
            <div className="flex justify-between items-center mt-3">
              <div>
                <div className="font-medium">{b.title}</div>
                <div className="text-xs text-slate-500">{b.position} • {b.is_active ? "Active" : "Inactive"}</div>
              </div>
              <Button size="icon" variant="ghost" onClick={() => del(b.id)} data-testid={`banner-delete-${b.id}`}><Trash2 className="h-4 w-4 text-rose-600" /></Button>
            </div>
          </Card>
        ))}
        {items.length === 0 && <p className="text-sm text-slate-400 col-span-2">No banners yet.</p>}
      </div>
    </div>
  );
}
